import genZIndexValues from './genZIndexValues';

export const zIndexValues = genZIndexValues(
  'stickyColumn',
  'stickyTableHead',
  'stickyToolbar',
  'documentsTableProgress',
  'priceAssistant',
  'navbar',
  'stickyHeader',
  'promptBar',
  'getStartedButton',
  ['intercom', 2147483001],
  'modalOverlayInactive',
  'modalInactive',
  'modalOverlay',
  'modal',
  'modalCloseIcon',
  'lightbox',
  'overlayBackground',
  'autocompleteSuggestions',
  'topLevelModalOverlay',
  'topLevelModal',
  'draggedTableRow',
  'popover',
  'inputIconTooltip',
  'overlayElement',
  'submenuLevel1',
  'submenuLevel2',
  'submenuLevel3',
  'submenuLevel4',
  'submenuLevel5',
  'submenuLevel6',
  'submenuLevel7',
  'submenuLevel8',
  'submenuLevel9',
  'submenuLevel10',
  'toast',
  'appOutdatedNotification',
  'dragMask',
  'loadingOverlay',
);
